export { languagesSk } from './sk';
export { languagesEn } from './en';
export { languagesCz } from './cz';

// Helper function to get languages by language
import { languagesSk } from './sk';
import { languagesEn } from './en';
import { languagesCz } from './cz';

export function getLanguages(lang: 'sk' | 'en' | 'cz') {
  switch (lang) {
    case 'sk':
      return languagesSk;
    case 'en':
      return languagesEn;
    case 'cz':
      return languagesCz;
    default:
      return languagesSk; // fallback to Slovak
  }
}
